import { classNames } from '../../../../utils/helpers';
import { CheckIcon } from '@heroicons/react/24/solid';
import ReactTooltip from 'react-tooltip';

interface StepsProps {
  branchColour?: string;
  steps: any[];
}

const Steps = ({ branchColour, steps }: StepsProps) => {
  if (!branchColour) {
    branchColour = 'primary';
  }
  return (
    <div aria-label="Progress" className="mx-auto">
      <ol role="list" className="flex items-center">
        {steps.map((step, stepIdx) => (
          <li
            key={step.name}
            className={classNames(
              stepIdx !== steps.length - 1 ? 'pr-4 sm:pr-4' : '',
              'relative'
            )}
          >
            {step.status === 'complete' ? (
              <>
                <div
                  className="absolute inset-0 flex items-center"
                  aria-hidden="true"
                >
                  <div
                    className={`h-0.5 w-full`}
                    style={{
                      backgroundColor: branchColour,
                    }}
                  />
                </div>
                <a
                  data-tip
                  data-for={`complete-${step.name}`}
                  href="#"
                  className={`relative flex h-5 w-5 items-center justify-center rounded-full`}
                  style={{
                    backgroundColor: branchColour,
                  }}
                >
                  <CheckIcon
                    className="h-5 w-5 text-white"
                    aria-hidden="true"
                  />
                  <span className="sr-only">{step.name}</span>
                </a>

                <ReactTooltip id={`complete-${step.name}`} type="success">
                  <span>{step.date}</span>
                </ReactTooltip>
              </>
            ) : step.status === 'current' ? (
              <>
                <div
                  className="absolute inset-0 flex items-center"
                  aria-hidden="true"
                >
                  <div className="h-0.5 w-full bg-gray-200" />
                </div>
                <a
                  href="#"
                  className="relative flex h-5 w-5 items-center justify-center rounded-full border-2 bg-white"
                  style={{
                    borderColor: branchColour,
                  }}
                  aria-current="step"
                >
                  <span
                    className="h-2.5 w-2.5 rounded-full"
                    style={{
                      backgroundColor: branchColour,
                    }}
                    aria-hidden="true"
                  />
                  <span className="sr-only">{step.name}</span>
                </a>
              </>
            ) : (
              <>
                <div
                  className="absolute inset-0 flex items-center"
                  aria-hidden="true"
                >
                  <div className="h-0.5 w-full bg-gray-200" />
                </div>
                <a
                  href="#"
                  className="group relative flex h-5 w-5 items-center justify-center rounded-full border-2 border-gray-300 bg-white hover:border-gray-400"
                >
                  <span
                    className="h-2.5 w-2.5 rounded-full bg-transparent group-hover:bg-gray-300"
                    aria-hidden="true"
                  />
                  <span className="sr-only">{step.name}</span>
                </a>
              </>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default Steps;
